import { render } from "./SvgSprite.vue?vue&type=template&id=33a22d3a&scoped=true"
import script from "./SvgSprite.vue?vue&type=script&lang=js"
export * from "./SvgSprite.vue?vue&type=script&lang=js"

import "./SvgSprite.vue?vue&type=style&index=0&id=33a22d3a&lang=scss&scoped=true"

import exportComponent from "/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33a22d3a"]])

export default __exports__